// bao migrate skip
import Bao from "../../../services/bao-service";
import TabPage from "../../../factories/tab-page";
import BaoDialog from "../../../factories/bao-dialog";
import GenericListTab from "../../../factories/generic-list-tab";
import * as ko from "knockout";
class RoleSummaryReportTab extends GenericListTab {
    Bao = Bao;
    DialogWidth = 800;
    /** used in dialog to control detail view is on/off */
    DetailedView = ko.observable(false);
    /** used in dialog to control detail view is on/off */
    toggleDetailedView = () => { this.DetailedView(!this.DetailedView()); };
    /** used in manual foreach selection table */
    SelectedRow = ko.observable({});
    SummaryReportName = ko.observable();
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.Models.subscribe(() => {
            this.Selection([]);
        });
        // hack which is need to get the toolbarbuttons work with the manual selection binding implementation
        this.SelectedRow.subscribe((value) => {
            this.Selection([value]);
        });
    }
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        var result = true;
        def.resolve(result);
        return def.promise();
    }
    /**
     * ko data-bind click event on dialog's detail button
     * @param data
     * @param event
     */
    OnClickDetailButton(data, event) {
        this.toggleDetailedView();
    }
    /**
     * opens the dialog, checks the edit permission before
     * @param primaryKeyValue
     */
    private OpenEditDialog(primaryKeyValue: string) {
        // check if btn "edit" is available (permitted) and cancel if not
        if (!this.ToolbarButtons().filter(x => ko.unwrap(x.ActionKey) === this.PermissionEdit).map(x => ko.unwrap(x.Visible))[0]) {
            return;
        }
        this.Dialog(ko.unwrap(primaryKeyValue));
    }
    /**
     * overrides GenericListTab's Dailog Method
     * @param itemId
     */
    Dialog(itemId: string) {
        // need to set DetailedView to false (=default), before calling the base method
        this.DetailedView(false);
        return super.Dialog(itemId);
    }
    /**
     * overrides GenericListTab.Save to check the server response
     * @param item
     */
    public Save(item) {
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlSave(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            model: item
        })).then((serverResult) => {
            if (serverResult) {
                if (serverResult.Result === false) {
                    new BaoDialog(null, serverResult.Message, "info");
                    // hack because the caller requires that this function uses an async this.Get() to unset IsLoading
                    window.setTimeout(() => {
                        this.TabPage.IsLoading(false);
                    }, 100);
                    return;
                }
            }
            return this.Get();
        });
    }
    ;
}
export default RoleSummaryReportTab;